import { cn } from '@core/utils/cn';

export type BadgeTone = 'accent' | 'teal' | 'muted' | 'admin' | 'danger' | 'success';

const TONES: Record<BadgeTone, string> = {
  accent: 'text-accent border-accent',
  teal: 'text-teal border-teal',
  muted: 'text-muted border-line',
  admin: 'text-admin border-admin',
  danger: 'text-danger border-danger',
  success: 'text-success border-success',
};

interface BadgeProps {
  readonly tone?: BadgeTone;
  /** Spells out what the tone means, as tooltip and accessible name. Required
   *  wherever the tone carries meaning, or colour is the only thing saying it. */
  readonly label?: string;
  readonly className?: string;
  readonly children: React.ReactNode;
}

/** Small uppercase status pill (read-only / read & write / roles). */
export function Badge({
  tone = 'muted',
  label,
  className,
  children,
}: BadgeProps): React.JSX.Element {
  return (
    <span
      title={label}
      aria-label={label}
      className={cn(
        'dda-readout inline-flex items-center rounded-md border px-2 py-0.5',
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
